"use client";

import { useServiceData } from "../../hooks/useServiceData";
import React from "react";
import styles from "./MultiVendorEcommerceServicesCardSection.module.css";
import ServiceCard from "../../components/ServiceCard";
import multiVendorServicesData from "../../data/multi-vendor-ecommerce";

export default function MultiVendorEcommerceServicesCardSection() {
  const { data: backendPageData } = useServiceData();
  const services = backendPageData?.services;
  const displayData = services?.items || multiVendorServicesData;

  return (
    <section className={styles.section}>
      <div className="container">
        <div className="text-center mb-4" data-reveal="slide-up">
          <div className={styles.eyebrow}>{services?.title || "MULTI‑VENDOR E‑COMMERCE"}</div>
          <h2 className={styles.title}>{services?.subtitle || "Multi‑Vendor E‑commerce Services"}</h2>
        </div>

        <div className="row g-3 g-md-4" data-reveal="stagger-up">
          {displayData.map((card) => (
            <div className="col-12 col-md-6 col-lg-4" key={card.title}>
              <ServiceCard
                title={card.title}
                description={card.description}
                bullets={card.bullets} tags={card.tags}
                minHeight={card.minHeight}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
